export default "__VITE_ASSET__DR87eoWx__"